export default __webpack_public_path__ + "static/media/coupon.fbaf1192.svg";